/* eslint-disable no-param-reassign */
import tutorialDefinitions from '@/constants/tutorials';
import {
  getTutorialCache,
  setTutorialCache,
  removeTutorialCache,
} from '@/utils/tutorialStorage';

export default {
  namespaced: true,
  state: {
    tutorialActive: false,
    tutorialElements: {},
  },
  mutations: {
    SET_TUTORIAL_ACTIVE: (state, active) => {
      state.tutorialActive = !!active;
    },
    SET_TUTORIAL: (state, tutorial) => {
      state.tutorialElements = tutorial;
    },
    SET_ELEMENT_DONE: (state, { id, done }) => {
      if (id) {
        const newState = { ...state.tutorialElements };
        if (!newState[id]) newState[id] = {};
        newState[id].done = !!done;
        state.tutorialElements = newState;
      }
    },
  },
  getters: {
    getTutorialActive: state => state.tutorialActive,
    getTutorialElements: state => state.tutorialElements,
    getTutorialShow: state => (id) => {
      const element = state.tutorialElements[id];
      if (!element) return false;

      const { done, pres, link } = element;
      let show = !done;
      if (show && pres) {
        pres.forEach((preId) => {
          if (!state.tutorialElements[preId]?.done) {
            show = false;
          }
        });
      }
      if (show && link) {
        show = !link.every(linkId => state.tutorialElements[linkId].done);
      }
      return show;
    },
    getTutorialText: state => (id) => {
      const { text } = state.tutorialElements[id] || {};
      return text || '';
    },
  },
  actions: {
    resetTutorial: async ({ commit, getters }) => {
      await commit('SET_TUTORIAL_ACTIVE', false);
      await removeTutorialCache();
      let tutorials = {};
      if (tutorialDefinitions) {
        tutorials = JSON.parse(JSON.stringify(tutorialDefinitions));
      }
      await commit('SET_TUTORIAL', tutorials);
      await setTutorialCache(JSON.stringify(getters.getTutorialElements));
      await commit('SET_TUTORIAL_ACTIVE', true);
    },
    initTutorial: async ({ commit }) => {
      let tutorials = {};
      if (tutorialDefinitions) {
        tutorials = JSON.parse(JSON.stringify(tutorialDefinitions));
      }
      const cachedTutorial = await getTutorialCache();
      if (cachedTutorial) {
        const cachedTutorialObject = JSON.parse(cachedTutorial);
        Object.keys(cachedTutorialObject).forEach((id) => {
          if (!tutorials[id]) tutorials[id] = {};
          tutorials[id].done = cachedTutorialObject[id].done;
        });
        if (
          cachedTutorialObject.profile_stat_signups?.done
          && tutorials.profile_stat_reviews
        ) {
          tutorials.profile_stat_reviews.done = true;
        }
      }
      commit('SET_TUTORIAL', tutorials);
      commit('SET_TUTORIAL_ACTIVE', true);
    },
    setTutorialElementDone: async ({ commit, dispatch }, { id, done }) => {
      await commit('SET_ELEMENT_DONE', { id, done });
      await dispatch('updateTutorialCache');
    },
    updateTutorialCache: async ({ getters }) => {
      if (getters.getTutorialElements) {
        await removeTutorialCache();
        await setTutorialCache(JSON.stringify(getters.getTutorialElements));
      }
    },
  },
};
